import React, { useState } from "react";
import { IconButton, Tooltip } from "@mui/material";
import PaymentsOutlinedIcon from "@mui/icons-material/PaymentsOutlined";
import { MimshakData } from "../../../interfaces/DTO/mimshakData";
import { CreateOneTimeDepositDialog } from "./CreateOneTimeDepositDialog";

interface CreateOneTimeDepositButtonProps {
  row?: MimshakData;
}

const CreateOneTimeDepositButton: React.FC<CreateOneTimeDepositButtonProps> = ({ row }) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Tooltip
        title={row ? `בקשת הפקדה חד פעמית - פוליסה ${row.policy_number}` : "בחר שורה כדי לבקש הפקדה חד פעמית"}
        placement="top"
      >
        <span>
          <IconButton size="small" onClick={() => setOpen(true)} disabled={!row}>
            <PaymentsOutlinedIcon fontSize="small" />
          </IconButton>
        </span>
      </Tooltip>

      {open && row && (
        <CreateOneTimeDepositDialog open={open} row={row} onClose={() => setOpen(false)} />
      )}
    </>
  );
};

export default CreateOneTimeDepositButton;
